export default __webpack_public_path__ + "static/media/img_01.7c66f5b9.png";